import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import _ from 'lodash'

import { getCustomIntl } from 'config/config'
import { dispatchFundDetailEvent } from 'utils/tracking'
import { Button } from 'gdpp-components/dist/cjs/components/atoms'
import { Table } from 'gdpp-components/dist/cjs/components/molecules'

import Loader from '../../atoms/Loader'
import GridContainer from '../../atoms/FoundationGrid/GridContainer'
import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'
import Switch from '../../atoms/Switch'
import PageLevelMessage from '../../atoms/PageLevelMessage'
import CustomHighchart from '../../molecules/CustomHighchart'

import './style.scss'

const FundDetailPerformanceTab = ({
  apiHasError,
  pastPerformanceDisclaimer,
  highchartToggleConfig,
  highchartOptions,
  downloadOptions,
  tableDataArray,
  isYoungFund
}) => {
  const intl = getCustomIntl()
  const [selectedChart, setSelectedChart] = useState()

  const onChartRangeChange = (item) => {
    dispatchFundDetailEvent('period', item.id)
  }

  const handleChartTabChange = ({ item }) => {
    setSelectedChart(item.id)
    dispatchFundDetailEvent('graph', item.id)
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 0)
  }

  useEffect(() => {
    if (highchartToggleConfig.selectedChart) {
      setSelectedChart(highchartToggleConfig.selectedChart)
    }
  }, [highchartToggleConfig.selectedChart])

  return (
    <GridContainer extraClasses="fil-fund-detail__tab-performance">
      {isYoungFund && !apiHasError && (
        <Grid extraClasses="fil-fund-detail__tab-performance__page-level-message-container align-center">
          <Cell extraClasses="small-12 large-8 fil-fund-detail__tab-performance__page-level-message">
            <PageLevelMessage content={intl.formatMessage({ id: 'fundDetail.tabs.performanceTab.youngFundMessage' })} />
          </Cell>
        </Grid>
      )}
      <Grid extraClasses="fil-fund-detail__tab-performance__chart-header">
        <Cell extraClasses="fil-fund-detail__tab-performance__chart-toggle large-auto">
          {!_.isEmpty(highchartToggleConfig) && (
            <Switch
              id={highchartToggleConfig.id}
              defaultSelectedId={highchartToggleConfig.selectedChart}
              items={highchartToggleConfig.highchartToggleContent}
              onChange={handleChartTabChange}
            />
          )}
        </Cell>
        {selectedChart === 'nav' && (
          <Cell
            id="fil-fund-detail__history-download"
            extraClasses="fil-fund-detail__tab-performance__chart-download large-auto align-right align-self-middle"
          >
            <Button
              kind="textlink"
              icon="download-bottom"
              iconPosition="left"
              iconSize="16"
              label={downloadOptions.label}
              url={downloadOptions.url}
              extraClasses="fil-fund-detail__tab-performance__chart-download-link"
            />
          </Cell>
        )}
      </Grid>
      {pastPerformanceDisclaimer && <div className="fil-fund-detail__tab-performance__chart-message">{pastPerformanceDisclaimer}</div>}
      {apiHasError ? (
        <Grid extraClasses="fil-fund-detail__tab-performance__api-level-message-container">
          <Cell extraClasses="small-12 large-8">
            <PageLevelMessage id="fil-fund-detail__portfolio-tab-error-msg" content={intl.formatMessage({ id: 'dataErrorMessage' })} />
          </Cell>
        </Grid>
      ) : (
        <Grid extraClasses="fil-fund-detail__tab-performance__chart-container">
          <Cell extraClasses="large-12 fil-fund-detail__tab-performance__chart-items">
            {!_.isEmpty(highchartOptions) ? (
              Object.entries(highchartOptions).map(([key, value], index) => {
                return (
                  <div
                    key={`fil-fund-detail__tab-performance__${index}-chart`}
                    className={classnames(`fil-fund-detail__tab-performance__${key}-chart`, {
                      show: selectedChart === key
                    })}
                  >
                    <CustomHighchart
                      id={`fil-fund-detail__tab-performance__${index}-chart`}
                      options={value.options}
                      commonOptions={value.commonOptions}
                      onChartRangeChange={onChartRangeChange}
                    />
                  </div>
                )
              })
            ) : (
              <Loader />
            )}
          </Cell>
        </Grid>
      )}
      <Grid extraClasses="fil-fund-detail__tab-performance__table-container">
        {tableDataArray.map(({ id, title, tableData, ...restProps }) => {
          if (tableData.hasError) {
            return (
              <Cell
                key={`fil-fund-detail__tab-performance__table_${title}`}
                extraClasses="fil-fund-detail__tab-performance__table grid-x large-12"
              >
                <div className="text-heading-s fil-table--title text-left hasErrorTitle">{title}</div>
                <Cell extraClasses="small-12 large-8">
                  <PageLevelMessage
                    id="fil-fund-detail__portfolio-tab-error-msg"
                    content={intl.formatMessage({ id: 'dataErrorMessage' })}
                  />
                </Cell>
              </Cell>
            )
          }
          return (
            <Cell
              key={`fil-fund-detail__tab-performance__table_${title}`}
              extraClasses="fil-fund-detail__tab-performance__table grid-x large-12"
            >
              <Table {...tableData} title={title} isAutoFitWidth size="small" isScrollable={false} {...restProps} />
            </Cell>
          )
        })}
      </Grid>
    </GridContainer>
  )
}

FundDetailPerformanceTab.propTypes = {
  highchartOptions: PropTypes.object,
  highchartToggleConfig: PropTypes.object,
  downloadOptions: PropTypes.object.isRequired,
  tableDataArray: PropTypes.array,
  // tableDisclaimer: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  isYoungFund: PropTypes.bool,
  apiHasError: PropTypes.bool,
  pastPerformanceDisclaimer: PropTypes.string
}

FundDetailPerformanceTab.defaultProps = {
  highchartToggleConfig: {},
  highchartOptions: {},
  tableDataArray: [],
  // tableDisclaimer: '',
  isYoungFund: false,
  apiHasError: false,
  pastPerformanceDisclaimer: ''
}

export default FundDetailPerformanceTab
